export default __webpack_public_path__ + "static/media/When.770c679c.png";